import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiAlertTriangle, FiCalendar, FiChevronRight, FiClipboard } from 'react-icons/fi';
import styles from '../Dashboard.module.css';
import { getStatusIconClass } from './dashboardSummaryHelpers';

// The "My Surveys" summary card — mirrors QuizzesSummaryCard.jsx. This is the
// persistent, keeps-showing-up half of the login reminder (the other half is
// the one-time in-app notification fired when a survey is first assigned).
export default function SurveysSummaryCard({
  formatDueDate, getSurveyStatus, handleSurveyClick, loaded, surveySummary, recentSurveys,
}) {
  return (
    <motion.div
      className={styles.summaryCard}
      initial={false}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.summaryHeader}>
        <h3 className={styles.summaryTitle}>
          <FiClipboard aria-hidden="true" style={{ marginRight: 6 }} />
          My Surveys
        </h3>
        <Link to="/student/surveys" className={styles.viewAllButton}>
          View All
        </Link>
      </div>
      <div className={styles.summaryContent}>
        <div className={styles.summaryStats}>
          <div className={styles.summaryStatPill}>
            <span className={styles.summaryStatValue}>{surveySummary.open}</span>
            <span className={styles.summaryStatLabel}>Open</span>
          </div>
          <div className={styles.summaryStatPill}>
            <span className={styles.summaryStatValue}>{surveySummary.completed}</span>
            <span className={styles.summaryStatLabel}>Completed</span>
          </div>
          {surveySummary.overdue > 0 && (
            <div className={`${styles.summaryStatPill} ${styles.overdueChip}`}>
              <span className={styles.summaryStatValue}>{surveySummary.overdue}</span>
              <span className={styles.summaryStatLabel}>Overdue</span>
            </div>
          )}
        </div>
        <div className={styles.summaryItems}>
          {recentSurveys.length > 0 ? (
            recentSurveys.map((survey) => {
              const status = getSurveyStatus(survey);
              return (
                <div
                  key={survey.assignment_id}
                  className={styles.listRow}
                  onClick={() => handleSurveyClick(survey.assignment_id)}
                  role="button"
                  tabIndex={0}
                  aria-label={survey.title}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleSurveyClick(survey.assignment_id);
                    }
                  }}
                >
                  <div className={getStatusIconClass(status)}>
                    {status === 'overdue' ? <FiAlertTriangle size={16} /> : <FiClipboard size={16} />}
                  </div>
                  <div className={styles.rowMain}>
                    <div className={styles.summaryItemTitle}>{survey.title}</div>
                    {survey.closes_at && (
                      <div className={styles.rowMeta}>
                        <FiCalendar size={12} />
                        {formatDueDate(survey.closes_at)}
                      </div>
                    )}
                  </div>
                  <div className={styles.rowChevron}>
                    <FiChevronRight size={16} />
                  </div>
                </div>
              );
            })
          ) : loaded ? (
            <div className={styles.emptySummary}>
              <FiClipboard />
              <p>No surveys yet</p>
            </div>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
}
